// 英文译文 · 费用申请 / 发票与 PO(Expenses.vue / Invoices.vue / api/finance.ts / api/invoiceApi.ts)· key = 代码里的中文原文,一字不差
export default {
  // ── 费用分类(api/finance.ts · EXPENSE_CATEGORY_GROUPS)──
  "人事": "Personnel",
  "工资": "Salaries",
  "社保": "Social Insurance",
  "福利费": "Employee Benefits",
  "餐费": "Meals",
  "人力资源": "Human Resources",
  "场地办公": "Premises & Office",
  "房租水电费": "Rent & Utilities",
  "停车费": "Parking",
  "办公": "Office Expenses",
  "差旅": "Travel",
  "招待": "Entertainment",
  "市场推广": "Marketing",
  "电商运营": "E-commerce Operations",
  "物流": "Logistics",
  "财税与服务": "Tax, Finance & Services",
  "税费": "Taxes & Duties",
  "财务费用": "Finance Costs",
  "咨询费": "Consulting Fees",
  "专业服务": "Professional Services",
  "IT / 软件": "IT / Software",
  "其他": "Other",
  // ── 退款来源 / 退款方式(api/finance.ts)──
  "客户退款": "Customer Refund",
  "平台退款": "Platform Refund",
  "运费调整": "Freight Adjustment",
  "平台原路退款": "Refund via Platform (Original Method)",
  "钱包/账户": "Wallet / Account",
  // ── 收款方式 / 附件类型(前端选项 + 后端 payee_method_label / kind_label)──
  "银行转账": "Bank Transfer",
  "支付宝": "Alipay",
  "微信": "WeChat Pay",
  "现金": "Cash",
  "收款码": "Payment QR Code",
  "凭证": "Voucher",
  // ── 发票类型 / 状态(api/invoiceApi.ts)──
  "增值税专票": "Special VAT Invoice",
  "普通发票": "General Invoice",
  "形式发票": "Proforma Invoice",
  "出口发票": "Export Invoice",
  "商业发票": "Commercial Invoice",
  "已开出": "Issued",
  "部分收付": "Partially Settled",
  "已结清": "Settled",
  // ── 费用申请 · 列表 ──
  "费用/报销 · 一审工作流 · 打印审批单": "Expenses / reimbursements · Single-step review · Print approval forms",
  "搜单号/标题/收款方": "Search No. / title / payee",
  "全部分类": "All categories",
  "去设置 →": "Go to Settings →",
  "按当前筛选条件导出": "Export with the current filters",
  "+ 新建费用申请": "+ New Expense Request",
  "标题": "Title",
  "所属月份": "Expense Month",
  "计划付款日": "Planned Payment Date",
  "提交一审": "Submit for Review",
  "一审通过": "Approve",
  "待 {name} 审批": "Awaiting approval by {name}",
  "一审:任一管理员(未指定审批人)": "Review: any admin (no approver assigned)",
  "一审审批人:{name}": "Approver: {name}",
  "只显示你自己的申请": "Showing only your own requests",
  "你是审批人:显示你自己的 + 别人已提交的": "You are an approver: showing your own + others' submitted requests",
  "你是核票人:显示你自己的 + 别人一审通过的": "You are the invoice checker: showing your own + others' approved requests",
  "核票:任一管理员": "Invoice check: any admin",
  "核票:{name} / 管理员": "Invoice check: {name} / admins",
  "上传发票": "Upload invoice",
  "付款账户": "Paying account",
  "从哪个账户付的 · 可选也可手填(打印单上印)": "Which account paid · pick or type (printed on the form)",
  "选填:银行流水号": "Optional: bank reference",
  "已传发票 {n}": "Invoices uploaded: {n}",
  "已上传,等核票 · 要补传或删掉传错的,点开详情": "Uploaded, awaiting invoice check · open the details to add more or remove a wrong file",
  "补传发票": "Upload more invoices",
  "发票 / 凭证附件": "Invoices / vouchers",
  "申请人还没传发票": "The applicant has not uploaded an invoice yet",
  "{who} 上传 · {at}": "Uploaded by {who} · {at}",
  "已按数电发票文件名自动填好号码和开票日期 · 请打开发票核对": "Number and issue date pre-filled from the e-invoice file name · open the invoice to verify",
  "已上传 {n} 张发票 · 等核票": "Uploaded {n} invoice file(s) · awaiting invoice check",
  "备用:{name}": "Backup: {name}",
  "费用申请_{date}.xlsx": "Expense_Requests_{date}.xlsx",
  "导出失败:{msg}": "Export failed: {msg}",
  // ── 费用申请 · 新建 / 编辑 ──
  "编辑费用申请": "Edit Expense Request",
  "新建费用申请": "New Expense Request",
  "子分类": "Subcategory",
  "选填": "Optional",
  "办公室 2 月租金": "Office rent for February",
  "说明": "Description",
  "收款方类型": "Payee Type",
  "外部": "External",
  "内部": "Internal",
  "收款人名称": "Payee Name",
  "出纳照这个名字打款": "The cashier pays to this name",
  "收款方式": "Payment Method",
  "方式名称,如 PayPal / Wise": "Method name, e.g. PayPal / Wise",
  "开户行": "Bank",
  "如 招商银行深圳分行": "e.g. China Merchants Bank, Shenzhen Branch",
  "银行账号": "Bank Account No.",
  "支付宝账号": "Alipay Account",
  "微信号": "WeChat ID",
  "收款账号": "Payee Account",
  "提交审核前必填 · 出纳靠它打款": "Required before submitting for review · The cashier pays to this account",
  "手机号 / 邮箱 / 账号 · 跟收款码至少要有一个": "Phone / email / account · This or a payment QR code is required",
  "(保存后上传)": " (uploaded when saved)",
  "选择图片": "Choose image",
  "或点这里后按": "or click here and press",
  "粘贴微信里复制的收款码截图": "to paste a payment QR code screenshot copied from WeChat",
  "(会替换当前这张)": " (replaces the current one)",
  "现金支付不需要账户信息": "Cash payments need no account details",
  "其他账户信息": "Other Account Details",
  "选填 · SWIFT / 分行代码等补充": "Optional · SWIFT / branch code, etc.",
  "费用所属月份": "Expense Month",
  "这笔费用属于哪个月 · 损益按这个月入账 · 如 9 月补报 8 月房租就选 8 月": "The month this expense belongs to · It is booked to this month in the P&L · e.g. for August rent filed in September, choose August",
  "项目": "Item",
  "行合计": "Line Total",
  "合计": "Total",
  "凭证附件(发票 / 小票 / 报销凭证)": "Voucher Attachments (invoices / receipts / reimbursement vouchers)",
  "保存后上传": "uploaded when saved",
  "移除": "Remove",
  "选择文件": "Choose files",
  "粘贴截图 · 图片或 PDF,每个不超过 5MB · 审批后附件锁定": "to paste a screenshot · Images or PDF, max 5MB each · Attachments are locked after approval",
  // ── 费用申请 · 提示 ──
  "收款码要传图片": "The payment QR code must be an image",
  "只支持图片(jpg / png / webp / gif)和 PDF": "Only images (jpg / png / webp / gif) and PDF are supported",
  "{name} 超过 5MB": "{name} exceeds 5MB",
  "剪贴板里没有图片 · 先在微信里复制收款码截图": "No image in the clipboard · Copy the payment QR code screenshot in WeChat first",
  "已粘贴收款码 · 保存后上传": "Payment QR code pasted · It will be uploaded when you save",
  "剪贴板里没有文件或图片": "No file or image in the clipboard",
  "删除{kind}「{name}」?": "Delete {kind} \"{name}\"?",
  "删除附件": "Delete Attachment",
  "标题必填": "Title is required",
  "收款人名称必填": "Payee name is required",
  "银行账号还没填 · 提交审核前必须补上,否则出纳没法打款": "Bank account No. is empty · It must be filled in before submitting for review, or the cashier cannot pay",
  "收款账号和收款码都还没有 · 提交审核前至少要有一个": "No payee account or payment QR code yet · At least one is required before submitting for review",
  "单据已保存,但这些附件没传上去:{list}": "Saved, but these attachments failed to upload: {list}",
  "已建单": "Request created",
  "一审通过 · 备注": "Approve · Comment",
  "审批": "Approval",
  "可留空": "Optional",
  "已通过": "Approved",
  "需要另一位管理员审批 · 提交人不可自审": "Another admin must approve · Submitters cannot approve their own requests",
  "驳回原因": "Rejection reason",
  "驳回原因必填": "Rejection reason is required",
  "作废费用申请 {no}?": "Void expense request {no}?",
  "作废后这张单不能再修改,也不能恢复;要重新报销只能新建一张。": "A voided request can no longer be edited or restored; to claim again you have to create a new one.",
  "确认作废": "Void",
  "再想想": "Keep it",
  // ── 费用申请 · 详情 ──
  "费用申请 {no}": "Expense Request {no}",
  "费用申请详情": "Expense Request Details",
  "收款人": "Payee",
  "开户行 / 账号": "Bank / Account No.",
  "⚠ 未填 · 出纳无法打款": "⚠ Not filled in · The cashier cannot pay",
  "现金支付": "Cash Payment",
  "凭证附件": "Voucher Attachments",
  "审批时间": "Approved at",
  "审批意见": "Approval Comment",
  // ── 发票与 PO · 列表 ──
  "开出/收到发票元数据 · MVP 无 PDF": "Issued / received invoice metadata · MVP, no PDF",
  "发出": "Issued",
  "收到": "Received",
  "我方开出": "Issued by Us",
  "收到发票": "Received Invoices",
  "搜发票号/对方名/对方发票号": "Search invoice No. / counterparty / their invoice No.",
  "全部客户": "All customers",
  "全部供应商": "All suppliers",
  "+ 新建发票": "+ New Invoice",
  "方向": "Direction",
  "发票日期": "Invoice Date",
  "到期日": "Due Date",
  "对方": "Counterparty",
  "含税总额": "Total (incl. Tax)",
  "已收付": "Amount Settled",
  "开出发票": "Issue Invoice",
  "入账": "Post",
  "记录付款": "Record Payment",
  "标记已付": "Mark Paid",
  // ── 发票与 PO · 新建 / 编辑 ──
  "编辑发票": "Edit Invoice",
  "新建发票": "New Invoice",
  "发出(客户)": "Issued (customer)",
  "收到(供方)": "Received (supplier)",
  "发票类型": "Invoice Type",
  "对方发票号": "Counterparty Invoice No.",
  "供方发票号": "Supplier's invoice No.",
  "对方名称快照": "Counterparty Name (Snapshot)",
  "从档案默认带入": "Filled in from the master record by default",
  "对方税号": "Counterparty Tax ID",
  "增值税号/RFC 等": "VAT No. / RFC, etc.",
  "主税率": "Default Tax Rate",
  "关联 SO ID": "Linked SO ID",
  "关联 PO ID": "Linked PO ID",
  "扫描件 URL/KEY": "Scan URL/KEY",
  "描述": "Description",
  "商品/服务描述": "Goods / service description",
  "税额": "Tax Amount",
  "行合计(含税)": "Line Total (incl. Tax)",
  // ── 发票与 PO · 提示 ──
  "请选客户": "Please select a customer",
  "请选供应商": "Please select a supplier",
  "发票日期必填": "Invoice date is required",
  "至少 1 行明细": "At least 1 line item is required",
  "第 {n} 行描述必填": "Line {n}: description is required",
  "已创建 draft": "Draft created",
  "确认开出发票 {no}?": "Issue invoice {no}?",
  "确认将发票 {no} 入账?": "Post invoice {no} to the books?",
  "已入账": "Posted",
  "将 {no} 全额标记已收?": "Mark {no} as fully received?",
  "将 {no} 全额标记已付?": "Mark {no} as fully paid?",
  "已标记": "Marked",
  "记录一笔收款 · 尚欠 {currency} {amount}": "Record a receipt · Outstanding {currency} {amount}",
  "记录一笔付款 · 尚欠 {currency} {amount}": "Record a payment · Outstanding {currency} {amount}",
  "金额必须是数字": "Amount must be a number",
  "金额必须 > 0": "Amount must be > 0",
  "已记录": "Recorded",
  "作废 {no}?": "Void {no}?",
  // ── 发票与 PO · 详情 ──
  "发票 {no}": "Invoice {no}",
  "发票详情": "Invoice Details",
  "不含税小计": "Subtotal (excl. Tax)",
  "关联 SO": "Linked SO",
  "关联 PO": "Linked PO",
  "扫描件": "Scan",
  // 2026-09-24 核票 + 出纳付款
  "待核票": "Invoice Pending",
  "已核票": "Invoice Verified",
  "欠票·先付后补": "Invoice Owed · Paid First",
  "核票": "Check Invoice",
  "核票人": "Checked By",
  "核票说明": "Check Note",
  "核票:全部": "Invoice check: all",
  "显示已作废": "Show voided",
  "核票 · {no}": "Check Invoice · {no}",
  "核票通过": "Invoice verified",
  "核票通过@@按钮": "Verify",
  "先付后补": "Pay First, Invoice Later",
  "退回申请人": "Send Back",
  "退回": "Send Back",
  "退回 {no}?": "Send back {no}?",
  "退回要写原因(比如发票抬头不对、金额对不上)": "Enter a reason for sending it back (e.g. wrong invoice title, amount does not match)",
  "退回后单子变成「已驳回」,申请人改完要重新提交、重新走一审。": "It becomes \"Rejected\"; the applicant edits it, resubmits it and it goes through review again.",
  "已标记先付后补 · 可以付款了,票到了再来核": "Marked pay first, invoice later · It can be paid now; check the invoice when it arrives",
  "已退回申请人": "Sent back to the applicant",
  "已上传 {n} 个凭证": "Uploaded {n} voucher(s)",
  "已标记付款": "Marked as paid",
  "搜单号/标题/收款方/发票号": "Search No. / title / payee / invoice No.",
  "{name} 放行先付后补": "{name} allowed pay first, invoice later",
  "先付后补,票到了在这里补核": "Paid first · check the invoice here once it arrives",
  "还没有凭证": "No vouchers yet",
  "+ 补传凭证": "+ Upload Voucher",
  "发票号码": "Invoice No.",
  "开票日期": "Invoice Date",
  "+ 加一张发票": "+ Add Invoice",
  "说明(退回时必填:比如发票抬头不对、金额对不上)": "Note (required when sending back: e.g. wrong invoice title, amount does not match)",
  "核票通过:发票号码 + 开票日期至少一张,同一张发票不能在两张费用单上报。": "Verify: at least one invoice (number + date); the same invoice cannot be claimed on two expense requests.",
  "先付后补:票还没到,先让出纳付款,单子进欠票清单,票到了再来核。": "Pay first, invoice later: the invoice hasn't arrived — the cashier can pay now, the request goes on the owed-invoice list, check it when the invoice arrives.",
  "退回:单子回到申请人手里改,改完重新提交、重新走一审。": "Send back: the applicant edits the request, resubmits it and it goes through review again.",
  "标记付款 · {no}": "Mark Paid · {no}",
  "欠票:付款后记得回来核票": "Invoice owed: remember to check the invoice after paying",
  "付款@@按钮": "Mark Paid",
  "付款说明": "Payment Note",
  "选填:银行流水号 / 付款账户": "Optional: bank reference / paying account",
  "确认已付款": "Confirm Paid",
  "收款名称": "Payee Name",
  "收款名称必填": "Payee name is required",
  // 2026-09-28 费用申请列表显示申请人
  "申请人": "Applicant",
  "提交 {at}": "Submitted {at}",
  "未提交": "Not submitted",
  "这是链路自动开的发票 · 对方公司收到的那张会一起作废": "This invoice was issued automatically by the chain · the counterparty's received copy will be voided too",
  "没有对方档案的发票不能打对账单": "Invoices without a counterparty record cannot be printed as a statement",
  "月度对账单": "Monthly statement",
  "跨公司链路发货时自动开的 · 对方公司有对应的一张": "Issued automatically when the intercompany chain shipped · the counterparty has a matching invoice",
  "链路": "Chain",
  "月度对账单 · 应收(我方开出)": "Monthly statement · Receivable (issued by us)",
  "月度对账单 · 应付(收到的发票)": "Monthly statement · Payable (received invoices)",
  "按发票日期统计 · 草稿不算 · 作废的列出但不计金额": "By invoice date · drafts excluded · voided ones listed but not counted",
  "本月无发票": "No invoices this month",
  "上月结余未付": "Unpaid carried over",
  "本月开票": "Invoiced this month",
  "已付": "Paid",
  "期末未付": "Unpaid at month end",
  "发票号": "Invoice No.",
  "未付": "Unpaid",
  "请选择到账银行账户": "Please choose the receiving bank account",
  "请选择出账银行账户": "Please choose the paying bank account",
  "按这个月收到、还没付的链路发票,每家供应商生成一张待审批付款单(每月 1 号凌晨会自动生成上月的)": "Create one payment (pending approval) per supplier from this month's unpaid chain invoices (last month's are generated automatically early on the 1st)",
  "生成月结付款单": "Generate monthly payments",
  "对方公司付款后自动生成 · 核销发票:": "Created automatically when the counterparty paid · settles invoices: ",
  "月结": "Monthly",
  "未选 · 对账时选": "Not set · choose when reconciling",
  "到账账户": "Receiving account",
  "核销发票": "Settles invoices",
  "核对为「已对账 · 匹配」后,这些发票记为已收": "Once reconciled as matched, these invoices are marked received",
  "链路月结自动生成({month})· 发票:": "Generated by chain monthly settlement ({month}) · invoices: ",
  "计划": "Planned",
  "还没有 {ccy} 银行账户 · 先到「银行账户」页签建一个": "No {ccy} bank account yet · create one on the Bank Accounts tab first",
  "标记已付后这些发票记为已付,对方公司会收到一张待核对的收款单": "Marking as paid marks these invoices paid and gives the counterparty a receipt to reconcile",
  // 2026-10-10 费用申请:填过的收款方 + 复制
  "填过的收款方": "Saved payees",
  "选一个以前填过的,自动带出收款方和账户信息": "Pick a payee used before to fill in the payee and account details",
  "还没有填过的收款信息": "No payee details used yet",
  "用过 {n} 次": "Used {n}×",
  "尾号 {n}": "ending {n}",
  "有收款码": "QR code",
  "收款码.png": "payment-qr.png",
  "收款码没取回来 · 请重新上传": "Couldn't load the QR code · please upload it again",
  "照这张建一张新草稿 · 每月固定的费用用": "Create a new draft from this one · for recurring monthly expenses",
  "新建费用申请 · 复制自 {no}": "New expense request · copied from {no}",
} as Record<string, string>;
